import { default as Airplay } from './Airplay';
import { default as Alert } from './Alert';
import { default as Attach } from './Attach';
import { default as Backspace } from './Backspace';
import { default as Ban } from './Ban';
import { default as BarChart } from './BarChart';
import { default as Battery } from './Battery';
import { default as Billing } from './Billing';
import { default as BillingCircle } from './BillingCircle';
import { default as Book } from './Book';
import { default as Bookmark } from './Bookmark';
import { default as Box } from './Box';
import { default as Buildings } from './Buildings';
import { default as Calendar } from './Calendar';
import { default as CalendarAdd } from './CalendarAdd';
import { default as CalendarCircle } from './CalendarCircle';
import { default as CalendarDelete } from './CalendarDelete';
import { default as Camera } from './Camera';
import { default as Cart } from './Cart';
import { default as Caution } from './Caution';
import { default as CellIphone } from './CellIphone';
import { default as Chat } from './Chat';
import { default as CheckInCalendar } from './CheckInCalendar';
import { default as CheckInCalendarCircle } from './CheckInCalendarCircle';
import { default as CheckInConfirmation } from './CheckInConfirmation';
import { default as Checkmark } from './Checkmark';
import { default as ClassesAndEvents } from './ClassesAndEvents';
import { default as ClassesAndEventsCircle } from './ClassesAndEventsCircle';
import { default as Clock } from './Clock';
import { default as Cloud } from './Cloud';
import { default as Columns } from './Columns';
import { default as Compass } from './Compass';
import { default as Compose } from './Compose';
import { default as Connection } from './Connection';
import { default as Contract } from './Contract';
import { default as Cost } from './Cost';
import { default as CreditCard } from './CreditCard';
import { default as Crop } from './Crop';
import { default as Crosshair } from './Crosshair';
import { default as Cursor } from './Cursor';
import { default as Dashboard } from './Dashboard';
import { default as Database } from './Database';
import { default as Delete } from './Delete';
import { default as DeleteCalendar } from './DeleteCalendar';
import { default as Desktop } from './Desktop';
import { default as DirectDown } from './DirectDown';
import { default as DirectLeft } from './DirectLeft';
import { default as DirectRight } from './DirectRight';
import { default as DirectUpAscend } from './DirectUpAscend';
import { default as Dislike } from './Dislike';
import { default as DocumentRecords } from './DocumentRecords';
import { default as DocumentRecordsCircle } from './DocumentRecordsCircle';
import { default as Down } from './Down';
import { default as DownLeft } from './DownLeft';
import { default as DownRight } from './DownRight';
import { default as Download } from './Download';
import { default as DownloadCloud } from './DownloadCloud';
import { default as Drop } from './Drop';
import { default as Edit } from './Edit';
import { default as Eject } from './Eject';
import { default as Ellipsis } from './Ellipsis';
import { default as EllipsisChat } from './EllipsisChat';
import { default as EmptyBattery } from './EmptyBattery';
import { default as Enlighten } from './Enlighten';
import { default as Erase } from './Erase';
import { default as ExitLogout } from './ExitLogout';
import { default as Expand } from './Expand';
import { default as Facetime } from './Facetime';
import { default as FastForward } from './FastForward';
import { default as Fax } from './Fax';
import { default as FileDocument } from './FileDocument';
import { default as Fill } from './Fill';
import { default as Filter } from './Filter';
import { default as Flag } from './Flag';
import { default as Flask } from './Flask';
import { default as Font } from './Font';
import { default as Fork } from './Fork';
import { default as Globe } from './Globe';
import { default as GoPaperless } from './GoPaperless';
import { default as GridThumbnails } from './GridThumbnails';
import { default as HalfStar } from './HalfStar';
import { default as Halfheart } from './Halfheart';
import { default as Harddrive } from './Harddrive';
import { default as Healthylink } from './Healthylink';
import { default as Heart } from './Heart';
import { default as Help } from './Help';
import { default as HighBattery } from './HighBattery';
import { default as ImagePicture } from './ImagePicture';
import { default as Inbox } from './Inbox';
import { default as Info } from './Info';
import { default as Key } from './Key';
import { default as Laptop } from './Laptop';
import { default as Layout } from './Layout';
import { default as Left } from './Left';
import { default as Lightbulb } from './Lightbulb';
import { default as Like } from './Like';
import { default as Link } from './Link';
import { default as List } from './List';
import { default as Loading } from './Loading';
import { default as Location } from './Location';
import { default as Lock } from './Lock';
import { default as LowBattery } from './LowBattery';
import { default as LowVolume } from './LowVolume';
import { default as Mail } from './Mail';
import { default as Map } from './Map';
import { default as MediumBattery } from './MediumBattery';
import { default as Merge } from './Merge';
import { default as Mic } from './Mic';
import { default as Minus } from './Minus';
import { default as Move } from './Move';
import { default as Music } from './Music';
import { default as Navigate } from './Navigate';
import { default as NavigateDown } from './NavigateDown';
import { default as NavigateLeft } from './NavigateLeft';
import { default as NavigateRight } from './NavigateRight';
import { default as NavigateUp } from './NavigateUp';
import { default as News } from './News';
import { default as Notebook } from './Notebook';
import { default as Notification } from './Notification';
import { default as NotificationsDisabled } from './NotificationsDisabled';
import { default as Openbook } from './Openbook';
import { default as OutShare } from './OutShare';
import { default as Pause } from './Pause';
import { default as Phone } from './Phone';
import { default as PhoneDisabled } from './PhoneDisabled';
import { default as PieChart } from './PieChart';
import { default as Pin } from './Pin';
import { default as Play } from './Play';
import { default as Plus } from './Plus';
import { default as Prescription } from './Prescription';
import { default as PrescriptionCircle } from './PrescriptionCircle';
import { default as Print } from './Print';
import { default as ProfileUser } from './ProfileUser';
import { default as Quote } from './Quote';
import { default as Record } from './Record';
import { default as Redirect } from './Redirect';
import { default as Refresh } from './Refresh';
import { default as RemoveCalendar } from './RemoveCalendar';
import { default as Repeat } from './Repeat';
import { default as Replay } from './Replay';
import { default as Reply } from './Reply';
import { default as Retweet } from './Retweet';
import { default as Rewind } from './Rewind';
import { default as Right } from './Right';
import { default as RowsMenu } from './RowsMenu';
import { default as RssFeed } from './RssFeed';
import { default as Sample } from './Sample';
import { default as Search } from './Search';
import { default as Send } from './Send';
import { default as Settings } from './Settings';
import { default as SettingsCircle } from './SettingsCircle';
import { default as Shuffle } from './Shuffle';
import { default as Signpost } from './Signpost';
import { default as SkipNext } from './SkipNext';
import { default as Star } from './Star';
import { default as Stop } from './Stop';
import { default as Stroke } from './Stroke';
import { default as Sync } from './Sync';
import { default as TabletIpad } from './TabletIpad';
import { default as Tag } from './Tag';
import { default as Target } from './Target';
import { default as Text } from './Text';
import { default as ThumbGrid } from './ThumbGrid';
import { default as Timer } from './Timer';
import { default as Transfer } from './Transfer';
import { default as Trash } from './Trash';
import { default as Unlock } from './Unlock';
import { default as Up } from './Up';
import { default as Upleft } from './Upleft';
import { default as Upload } from './Upload';
import { default as UploadCloud } from './UploadCloud';
import { default as Upright } from './Upright';
import { default as Users } from './Users';
import { default as Video } from './Video';
import { default as View } from './View';
import { default as VolumeSpeaker } from './VolumeSpeaker';
import { default as Warehouse } from './Warehouse';
import { default as Wifi } from './Wifi';
import { default as Windows } from './Windows';
import { default as Work } from './Work';
import { default as WritingDisabled } from './WritingDisabled';
import { default as ZoomIn } from './ZoomIn';
import { default as ZoomOut } from './ZoomOut';
export default {
  Airplay: Airplay,
  Alert: Alert,
  Attach: Attach,
  Backspace: Backspace,
  Ban: Ban,
  BarChart: BarChart,
  Battery: Battery,
  Billing: Billing,
  BillingCircle: BillingCircle,
  Book: Book,
  Bookmark: Bookmark,
  Box: Box,
  Buildings: Buildings,
  Calendar: Calendar,
  CalendarAdd: CalendarAdd,
  CalendarCircle: CalendarCircle,
  CalendarDelete: CalendarDelete,
  Camera: Camera,
  Cart: Cart,
  Caution: Caution,
  CellIphone: CellIphone,
  Chat: Chat,
  CheckInCalendar: CheckInCalendar,
  CheckInCalendarCircle: CheckInCalendarCircle,
  CheckInConfirmation: CheckInConfirmation,
  Checkmark: Checkmark,
  ClassesAndEvents: ClassesAndEvents,
  ClassesAndEventsCircle: ClassesAndEventsCircle,
  Clock: Clock,
  Cloud: Cloud,
  Columns: Columns,
  Compass: Compass,
  Compose: Compose,
  Connection: Connection,
  Contract: Contract,
  Cost: Cost,
  CreditCard: CreditCard,
  Crop: Crop,
  Crosshair: Crosshair,
  Cursor: Cursor,
  Dashboard: Dashboard,
  Database: Database,
  Delete: Delete,
  DeleteCalendar: DeleteCalendar,
  Desktop: Desktop,
  DirectDown: DirectDown,
  DirectLeft: DirectLeft,
  DirectRight: DirectRight,
  DirectUpAscend: DirectUpAscend,
  Dislike: Dislike,
  DocumentRecords: DocumentRecords,
  DocumentRecordsCircle: DocumentRecordsCircle,
  Down: Down,
  DownLeft: DownLeft,
  DownRight: DownRight,
  Download: Download,
  DownloadCloud: DownloadCloud,
  Drop: Drop,
  Edit: Edit,
  Eject: Eject,
  Ellipsis: Ellipsis,
  EllipsisChat: EllipsisChat,
  EmptyBattery: EmptyBattery,
  Enlighten: Enlighten,
  Erase: Erase,
  ExitLogout: ExitLogout,
  Expand: Expand,
  Facetime: Facetime,
  FastForward: FastForward,
  Fax: Fax,
  FileDocument: FileDocument,
  Fill: Fill,
  Filter: Filter,
  Flag: Flag,
  Flask: Flask,
  Font: Font,
  Fork: Fork,
  Globe: Globe,
  GoPaperless: GoPaperless,
  GridThumbnails: GridThumbnails,
  HalfStar: HalfStar,
  Halfheart: Halfheart,
  Harddrive: Harddrive,
  Healthylink: Healthylink,
  Heart: Heart,
  Help: Help,
  HighBattery: HighBattery,
  ImagePicture: ImagePicture,
  Inbox: Inbox,
  Info: Info,
  Key: Key,
  Laptop: Laptop,
  Layout: Layout,
  Left: Left,
  Lightbulb: Lightbulb,
  Like: Like,
  Link: Link,
  List: List,
  Loading: Loading,
  Location: Location,
  Lock: Lock,
  LowBattery: LowBattery,
  LowVolume: LowVolume,
  Mail: Mail,
  Map: Map,
  MediumBattery: MediumBattery,
  Merge: Merge,
  Mic: Mic,
  Minus: Minus,
  Move: Move,
  Music: Music,
  Navigate: Navigate,
  NavigateDown: NavigateDown,
  NavigateLeft: NavigateLeft,
  NavigateRight: NavigateRight,
  NavigateUp: NavigateUp,
  News: News,
  Notebook: Notebook,
  Notification: Notification,
  NotificationsDisabled: NotificationsDisabled,
  Openbook: Openbook,
  OutShare: OutShare,
  Pause: Pause,
  Phone: Phone,
  PhoneDisabled: PhoneDisabled,
  PieChart: PieChart,
  Pin: Pin,
  Play: Play,
  Plus: Plus,
  Prescription: Prescription,
  PrescriptionCircle: PrescriptionCircle,
  Print: Print,
  ProfileUser: ProfileUser,
  Quote: Quote,
  Record: Record,
  Redirect: Redirect,
  Refresh: Refresh,
  RemoveCalendar: RemoveCalendar,
  Repeat: Repeat,
  Replay: Replay,
  Reply: Reply,
  Retweet: Retweet,
  Rewind: Rewind,
  Right: Right,
  RowsMenu: RowsMenu,
  RssFeed: RssFeed,
  Sample: Sample,
  Search: Search,
  Send: Send,
  Settings: Settings,
  SettingsCircle: SettingsCircle,
  Shuffle: Shuffle,
  Signpost: Signpost,
  SkipNext: SkipNext,
  Star: Star,
  Stop: Stop,
  Stroke: Stroke,
  Sync: Sync,
  TabletIpad: TabletIpad,
  Tag: Tag,
  Target: Target,
  Text: Text,
  ThumbGrid: ThumbGrid,
  Timer: Timer,
  Transfer: Transfer,
  Trash: Trash,
  Unlock: Unlock,
  Up: Up,
  Upleft: Upleft,
  Upload: Upload,
  UploadCloud: UploadCloud,
  Upright: Upright,
  Users: Users,
  Video: Video,
  View: View,
  VolumeSpeaker: VolumeSpeaker,
  Warehouse: Warehouse,
  Wifi: Wifi,
  Windows: Windows,
  Work: Work,
  WritingDisabled: WritingDisabled,
  ZoomIn: ZoomIn,
  ZoomOut: ZoomOut
};